module.exports = __webpack_public_path__ + "static/media/p5.6241a27a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/personalization/images/urbanhipster/p5.jpg
// module id = 2939
// module chunks = 0